export default __webpack_public_path__ + "static/media/Mystic's Boots of the Crumbling Tower.39be84c4.jpg";